// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_bk-0";
export var actionModalContentContainer = "_bk-1";
export var createTagButton = "_bk-2";
export var footerContainer = "_bk-7";
export var fullWidthDivider = "_bk-3";
export var hasCreateTagButton = "_bk-4";
export var noCreateTagButton = "_bk-5";
export var tagsContainer = "_bk-6";
export var tagsModalContentContainer = "_bk-8";